/**
 * 权益补贴 -- 图片提示文案
 */
export default function photoTip(val) {
    let str = '';
    switch (val) {
    case 'SXX':
        str = '包括商业保险、车辆正面45度图片、车架号图片、车损位置图片、维修发票（专票，抬头为成都路行通信息技术有限公司，项目为维修费）、车辆维修结算单、车辆行驶证、身份证、维修单位开户行信息、了结协议、凯励程服务函或业务清单';
        break;
    case 'SXX_2':
        // str = '事故车正面45度1张、车架号1张、车损图1-3张、车辆维修结算单、维修发票（专票）、客户身份证正反面、客户行驶证正反面、了结/支付协议、凯励程服务函或业务清单、商业保险单、收款人开户行信息（开户银行、银行账号、账户名）';
        str = '凭证必须包括：①车辆维修结算单照片（加盖维修单位售后章）②维修发票原件（抬头为中国太平洋财产保险股份有限公司上海分公司）③车损图（含带车牌整车图+车架号图+受损部位图）④行驶证正副页照片 ⑤索赔申请书 ⑥随修心2.0服务客户确认使用书 ⑦凯励程服务函或业务清单';
        break;
    case 'SXX_3':
        str = '凭证必须包括：①经销商维修结算单（需客户签字并加盖公章或售后服务章）②行驶证照片③车损图（含带车牌整车图+车架号图+受损部位图）④内饰照片（含仪表台及前档玻璃（与行车记录仪视频同视角）） ⑤车辆事故补偿确认函（需客户签字，并加盖经销店公章） ⑥案件索赔申请书⑦凯励程服务函或业务清单';
        break;
    case 'WXWY':
    case 'GCWY':
    case 'CCWY':
        str = '包括车辆正面45度图片、车架号图片、车损位置图片、维修发票（专票，抬头为成都路行通信息技术有限公司，项目为维修费）、车辆维修结算单、车辆行驶证、身份证、维修单位开户行信息、了结协议、凯励程服务函或业务清单';
        break;
    case 'ZJWY':
        str = '包括车辆正面45度图片、车架号图片、车损位置图片、购车发票、维修发票、车辆维修结算单、保险公司定损单、车辆行驶证、身份证、收款人开户行信息、了结协议、凯励程服务函或业务清单';
        break;
    case 'LSCX':
        str = '包括行驶证照片、身份证正反面照片、有日期证明的起止/截止里程数照片、权益补贴支付协议、凯励程服务函或业务清单';
        break;
    case 'CXWY':
        str = '包括行驶证照片、身份证正反面照片、上一年/当年商业险照片、权益补贴支付协议、凯励程服务函或业务清单';
        break;
    case 'JKRYW':
    case 'JCYW':
    case 'LTWY':
    case 'QSWY':
    case 'QSWYC':
    case 'YCWY':
    case 'YCWYB':
        str = '（根据合作保险公司要求提供即可）';
        break;
    default:
        break;
    }
    return str;
}
